import { html } from 'lit';
export class SortInfo {
    constructor(primaryFieldPosition, secondaryFieldPosition) {
        this.primaryFieldPosition = primaryFieldPosition;
        this.secondaryFieldPosition = secondaryFieldPosition;
    }
    isFound() {
        return this.primaryFieldPosition !== -1 || this.secondaryFieldPosition !== -1;
    }
}
SortInfo.NOT_FOUND = new SortInfo(-1, -1);
SortInfo.NO_FILTER = new SortInfo(0, 0);
SortInfo.LAST = new SortInfo(Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
SortInfo.compareFn = (left, right) => {
    if (left.primaryFieldPosition === right.primaryFieldPosition) {
        return left.secondaryFieldPosition - right.secondaryFieldPosition;
    }
    else if (left.primaryFieldPosition === -1) {
        return 1;
    }
    else if (right.primaryFieldPosition === -1) {
        return -1;
    }
    else {
        return left.primaryFieldPosition - right.primaryFieldPosition;
    }
};
const regEscape = (v) => v.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
export function applySearchAndReturnSortInfo(item, searchFilter) {
    searchFilter = searchFilter.trim();
    if (searchFilter.length === 0) {
        item.setPrimaryFieldHighlight && item.setPrimaryFieldHighlight();
        item.setSecondaryFieldHighlight && item.setSecondaryFieldHighlight();
        return SortInfo.NO_FILTER;
    }
    const regExp = new RegExp(regEscape(searchFilter), 'ig');
    const primaryField = item.getPrimaryField();
    const secondaryField = item.getSecondaryField();
    const primaryFieldParts = primaryField === undefined ? [] : primaryField.split(regExp);
    const primaryFieldPosition = primaryFieldParts.length > 1 ? primaryFieldParts[0].length : -1;
    const secondaryFieldParts = secondaryField === undefined ? [] : secondaryField.split(regExp);
    const secondaryFieldPosition = secondaryFieldParts.length > 1 ? secondaryFieldParts[0].length : -1;
    const highlightClass = item.getHighlightClass && item.getHighlightClass();
    item.setPrimaryFieldHighlight &&
        item.setPrimaryFieldHighlight(createHighlightTemplate(primaryFieldParts, primaryField, searchFilter.length, highlightClass));
    item.setSecondaryFieldHighlight &&
        item.setSecondaryFieldHighlight(createHighlightTemplate(secondaryFieldParts, secondaryField, searchFilter.length, highlightClass));
    return new SortInfo(primaryFieldPosition, secondaryFieldPosition);
}
function createHighlightTemplate(parts, field, highlightedLength, highlightClass) {
    if (parts.length < 2 || field === undefined || highlightClass === undefined) {
        return undefined;
    }
    let template = html ``;
    for (const part of parts) {
        const highlight = field.substring(part.length, part.length + highlightedLength);
        if (highlight.length === 0) {
            template = html `${template}${part}`;
        }
        else {
            template = html `${template}${part}<span class="${highlightClass}">${highlight}</span>`;
        }
        field = field.substring(part.length + highlightedLength);
    }
    return template;
}
